import { useEffect, useContext, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useLocation } from 'react-router';
import { store } from 'components/Store';
import useEmailDomainFunctions from 'components/Dashboard/hooks/useEmailDomainFunctions';

const useEmailDomainsInitialCall = () => {
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const location = useLocation();
  const { isAuthenticated } = useAuth0();
  const { getEmailAddressesCall, getEmailDomains, syncEmailDomain } = useEmailDomainFunctions();

  const call = useRef(null);
  call.current = async (source) => {
    try {
      if (isAuthenticated && !location?.state?.writingAssistantId) {
        //LOAD EMAIL DOMAINS AND EMAIL ADDRESSES
        // Email addresses don't depend on the domain sync/fetch below, so fetch them in
        // parallel instead of adding their round-trip to the end of that sequential chain.
        const emailAddressesPromise = getEmailAddressesCall(source);
        if (location.pathname.includes('/people/emails') || location.pathname === '/people/directory') {
          await syncEmailDomain({ isAdminPage: false, source });
        }
        let domainsResult = await getEmailDomains({ isAdminPage: false, source });
        let domainList = [];
        if (domainsResult?.length) {
          domainList = domainsResult.filter((e) => e.verificationStatus === 'Success');
        }
        const emailAddressesResult = await emailAddressesPromise;
        let emailsList = [];
        if (emailAddressesResult?.length) {
          emailsList = emailAddressesResult.filter((e) => e.isVerified);
        }
        if (!!domainsResult && !!emailAddressesResult) {
          dispatch({
            type: 'MODIFY_SECTION',
            parameter: 'listDomainsVerified',
            value: {
              verifiedDomains: domainList,
              allDomains: domainsResult,
              allEmailAddresses: emailAddressesResult,
              verifiedEmailAddresses: emailsList,
              domainsProccessing: false,
            },
          });
        }
        //
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const source = new AbortController();
    call.current(source);
    return () => {
      source.abort('Email domains canceled by the user.');
    };
  }, []);
};
export default useEmailDomainsInitialCall;
